// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"881":"3371bf68","1180":"3371bf68","2804":"b685943f","3251":"9b79cbba","3616":"3371bf68","5255":"3371bf68","5491":"3371bf68","6985":"3371bf68","8488":"86454a2c","9102":"3371bf68"}[chunkId] + ".chunk.css";
};